module.exports = __webpack_public_path__ + "static/media/Face_NonBinary_new.85494239.png";